import React from "react";
import "./Section1.css";
import Section1Image from "../../../../../assets/images/aliensrsec1img1.png";
import ProfDots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="aliensrsec1_section">
      <img src={ProfDots} alt="" className="aliensrsec1__section_dots" />
      <div className="aliensrsec1__section_left">
        <div className="aliensrsec1__secleft_heading">
          Who is a Non-resident Alien?
        </div>
        <div className="aliensrsec1__secleft_description">
          <p>
            A non-resident alien for tax purposes is a person who is not a
            citizen of the United States or a green card holder and is not
            considered “resident” in the United States for tax purposes.
          </p>
          <p>
            The basic test for “determining tax residency” is the substantial
            presence test. Under this test, an individual will be considered a
            U.S. resident for tax purposes if he or she is physically present in
            the United States on at least: (a) 31 days during the current
            calendar year; and (b) A total of 183 days during the current year
            and the 2 preceding years, counting all the days of physical
            presence in the current year, but only one-third the number of days
            of presence in the first preceding year, and only one-sixth the
            number of days in the second preceding year.
          </p>
          <p>
            In such case, a non-resident alien may be required to file a
            non-resident federal income tax return – the IRS Form 1040-NR. The
            Form 1040-NR is significantly less complex than the Form 1040 filed
            by U.S. persons, but it does present a number of
            information-gathering challenges.
          </p>
        </div>
      </div>
      <div className="aliensrsec1__section_right">
        <img src={Section1Image} alt="" className="aliensrsec1__section_img" />
      </div>
    </div>
  );
};

export default Section1;
